import { render } from "./GeneralStatisticView.vue?vue&type=template&id=799ac41d&scoped=true"
import script from "./GeneralStatisticView.vue?vue&type=script&lang=js"
export * from "./GeneralStatisticView.vue?vue&type=script&lang=js"

import "./GeneralStatisticView.vue?vue&type=style&index=0&id=799ac41d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799ac41d"]])

export default __exports__